import { Link } from "react-router-dom";
import Logo from "./Logo";
import { MonoLabel } from "./motion";

const TopoLines = () => (
    <svg aria-hidden className="absolute inset-0 w-full h-full opacity-[0.06] pointer-events-none" preserveAspectRatio="none" viewBox="0 0 1200 400">
        {[...Array(9)].map((_, i) => (
            <path
                key={i}
                d={`M-50 ${40 + i * 45} C 300 ${10 + i * 45}, 600 ${70 + i * 45}, 1250 ${30 + i * 45}`}
                fill="none"
                stroke="white"
                strokeWidth="1"
            />
        ))}
    </svg>
);

const Footer = () => (
    <footer className="relative border-t border-line bg-[#050505] overflow-hidden" data-testid="site-footer">
        <TopoLines />
        <div className="relative grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 border-b border-line">
            <div className="p-8 md:p-12 border-b md:border-b-0 lg:border-r border-line">
                <Logo variant="full" />
                <p className="mt-6 text-sm text-white/60 leading-relaxed max-w-xs">
                    Geotextiles, geogrids and engineered ground solutions for civil construction, infrastructure and earthworks.
                </p>
            </div>
            <div className="p-8 md:p-12 border-b md:border-b-0 lg:border-r border-line">
                <MonoLabel>Navigate</MonoLabel>
                <ul className="mt-6 space-y-3">
                    {[["/", "Home"], ["/about", "About"], ["/products", "Products"], ["/contact", "Contact"]].map(([to, label]) => (
                        <li key={to}>
                            <Link to={to} data-testid={`footer-${label.toLowerCase()}-link`} className="font-heading font-bold uppercase tracking-tight text-lg text-white/80 hover:text-[#FF5C00] transition-colors duration-300">
                                {label}
                            </Link>
                        </li>
                    ))}
                </ul>
            </div>
            <div className="p-8 md:p-12 border-b md:border-b-0 lg:border-r border-line">
                <MonoLabel>Products</MonoLabel>
                <ul className="mt-6 space-y-3 text-sm text-white/60">
                    <li><Link to="/products?cat=geocloth" data-testid="footer-geocloth-link" className="hover:text-white transition-colors duration-300">Geocloth</Link></li>
                    <li><Link to="/products?cat=geogrid" data-testid="footer-geogrid-link" className="hover:text-white transition-colors duration-300">Geogrid</Link></li>
                    <li><Link to="/products?cat=composite" data-testid="footer-composite-link" className="hover:text-white transition-colors duration-300">Composite Geocloth + Geogrid</Link></li>
                </ul>
            </div>
            <div className="p-8 md:p-12">
                <MonoLabel>Contact</MonoLabel>
                <ul className="mt-6 space-y-3 font-mono text-xs text-white/60 leading-relaxed">
                    <li data-testid="footer-phone">Regan Cording — <a href="tel:+64272068520" data-testid="footer-call-regan" className="hover:text-white transition-colors duration-300">027 206 8520</a></li>
                    <li>Hector Grant — <a href="tel:+64273404464" data-testid="footer-call-hector" className="hover:text-white transition-colors duration-300">027 340 4464</a></li>
                    <li data-testid="footer-email"><a href="mailto:sales@solidgroundsolutions.co.nz" className="hover:text-white transition-colors duration-300">sales@solidgroundsolutions.co.nz</a></li>
                    <li data-testid="footer-address">684 Tremaine Ave, Palmerston North, NZ</li>
                    <li data-testid="footer-hours">Mon–Fri 9:00am – 5:00pm</li>
                </ul>
            </div>
        </div>
        <div className="relative px-8 md:px-12 py-16 md:py-24 select-none">
            <p className="font-heading font-black uppercase tracking-tighter leading-[0.9] text-[10vw] text-outline" data-testid="footer-wordmark">
                Solid Ground Solutions
            </p>
        </div>
        <div className="relative flex flex-col md:flex-row items-start md:items-center justify-between gap-2 px-8 md:px-12 py-6 border-t border-line font-mono text-[10px] tracking-[0.2em] uppercase text-white/40">
            <span>© {new Date().getFullYear()} Solid Ground Solutions</span>
            <span>Engineered Solutions. Solid Ground.</span>
        </div>
    </footer>
);

export default Footer;
